export const tableHeaderMapper = {
  userName: 'name',
  email: 'email',
  phoneNumber: 'phone_number',
  residenceType: 'residence_type',
  kraStatus: 'kra_status',
  submittedOn: 'submitted_on'
};
